<h2 mat-dialog-title>Change price?</h2>
<mat-dialog-content>
  <p>
    You previously sold this item to this customer for a different price. Changing this price will also update each of
    this customer's existing subscriptions for this item
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Cancel</button>
  <button mat-flat-button [mat-dialog-close]="true" color="primary">Confirm</button>
</mat-dialog-actions>
